import { aboutInfo } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-6">
            {aboutInfo.title}
          </h2>

          <div className="text-sm md:text-base text-foreground-600 leading-relaxed text-left space-y-4 mb-8">
            {aboutInfo.description.split('\n\n').map((paragraph, i) => (
              <p key={i}>{paragraph}</p>
            ))}
          </div>

          <div className="grid grid-cols-3 gap-4 md:gap-6">
            {aboutInfo.stats.map((stat) => (
              <div key={stat.label} className="bg-background-50 rounded-xl p-4 md:p-6">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600 mb-1">{stat.value}</div>
                <div className="text-xs md:text-sm text-foreground-500">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}